document.addEventListener("DOMContentLoaded", function()
{
  const body = document.getElementsByTagName('body')[0];
  body.classList.remove('preload');
});